<script setup lang="ts">
/**
 * StagingBanner — sichtbar auf dem Staging (cms.miradev.de) und im Dev-Server.
 * Macht klar dass dieses CMS NICHT das produktive ist (Frau merkt nichts).
 *
 * Erkennung am Hostnamen: endet auf .miradev.de, enthält 'staging', oder hat
 * einen Port (= Dev-Server) — kein Build-Flag nötig, gleicher Code für beide
 * Deployments.
 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const isStaging = computed(() => {
  if (typeof window === 'undefined') return false
  const h = window.location.hostname
  // Dev-Server (localhost, 127.x, :port) gilt auch als staging-mäßig
  if (h === 'localhost' || h.startsWith('127.') || window.location.port !== '') {
    return true
  }
  // Konvention: alle Staging-Sites liegen unter miradev.de.
  // cms.miradev.de = miraCMS-Staging (David), <customer>.miradev.de = Customer-Sites.
  return h.endsWith('.miradev.de') || h.includes('staging')
})
</script>

<template>
  <div
    v-if="isStaging"
    class="shrink-0 px-3 py-1 text-[11px] font-medium text-center
           bg-amber-500/15 text-amber-700 dark:text-amber-300
           border-b border-amber-500/40"
    role="status"
  >
    ⚠ <i18n-t keypath="banner.staging" tag="span">
      <template #umgebung><strong>STAGING</strong></template>
    </i18n-t>
  </div>
</template>
